<template>
  <b-modal
    id="modal-history-activity"
    style="width: min-content; padding: 10px"
    hide-footer
    centered
    :noCloseOnBackdrop="false"
    :noCloseOnEsc="false"
    :hideHeaderClose="false"
    size="lg"
  >
    <div>
      <h1 class="title-modal-kinney mb-4">
        Historial de modificaciones realizadas de la actividad
      </h1>
      <b-table
        :items="recordsHistory"
        :fields="fields"
        :busy="isLoadingHistory"
        class="table-history-risk"
      >
        <template #cell(Detalles)="row" @click="row.toggleDetails">
          <template @click="row.toggleDetails">
            <a
              v-if="row.item.details[0]"
              size="sm"
              @click="row.toggleDetails"
              class="mr-2"
              style="cursor: pointer; color: #5d5fef; vertical-align: middle"
            >
              <img
                v-if="row.detailsShowing"
                class="centerImg1"
                src="@/assets/images/icons/arrow-drop-up-line.svg"
                width="20px"
              />

              <img
                v-else
                class="centerImg1 resaltar"
                src="@/assets/images/icons/eye-line.svg"
                width="20px"
              />

              {{ row.detailsShowing ? "Ocultar" : "Ver" }}
              Detalles
            </a>

            <p v-else>---</p>
          </template>
        </template>
        <template #table-busy>
          <div class="text-center my-2 mb-3">
            <OverlayButton clase="overlay-md"></OverlayButton>
          </div>
        </template>
        <template #row-details="row">
          <b-table
            :items="row.item.details"
            :fields="fields2"
            style="background-color: #f3f3f3"
          >
            <template #cell(oldValue)="row">
              <div v-if="row.item?.oldValue?.frequency">
                Probabilidad: {{ row.item?.oldValue?.frequency }}
              </div>
              <div v-if="row.item?.oldValue?.impact">
                Impacto: {{ row.item?.oldValue?.impact }}
              </div>
              <div v-if="row.item?.oldValue?.probability">
                Probabilidad: {{ row.item?.oldValue?.probability }}
              </div>
              <div
                v-if="
                  row.item?.oldValue?.risk_residual_description ||
                  row.item?.oldValue?.risk_description
                "
              >
                Descripción:
                {{
                  row.item.oldValue?.risk_residual_description ||
                  row.item.oldValue?.risk_description
                }}
              </div>
              <div
                v-if="
                  !row.item.oldValue?.impact &&
                  !row.item.oldValue?.probability &&
                  !row.item.oldValue?.frequency &&
                  !row.item.oldValue?.risk_description &&
                  !row.item.oldValue?.risk_residual_description
                "
                style="width: 300px; overflow: hidden;"
              >
                {{ row.item.oldValue }}
              </div>
            </template>
            <template #cell(newValue)="row">
              <div v-if="row.item.newValue?.frequency">
                Probabilidad: {{ row.item.newValue.frequency }}
              </div>
              <div v-if="row.item.newValue?.impact">
                Impacto: {{ row.item.newValue.impact }}
              </div>
              <div v-if="row.item.newValue?.probability">
                Probabilidad: {{ row.item.newValue.probability }}
              </div>
              <div
                v-if="
                  row.item.newValue?.risk_residual_description ||
                  row.item.newValue?.risk_description
                "
              >
                Descripción:
                {{
                  row.item.newValue.risk_residual_description ||
                  row.item.newValue.risk_description
                }}
              </div>
              <div
                v-if="
                  !row.item.newValue?.impact &&
                  !row.item.newValue?.probability &&
                  !row.item.newValue?.frequency &&
                  !row.item.newValue?.risk_description &&
                  !row.item.newValue?.risk_residual_description
                "
                style="width: 300px; overflow: hidden;"
              >
                {{ row.item.newValue }}
              </div>
            </template>
          </b-table>
        </template>
      </b-table>
      <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
        <Pagination
          v-if="dataHistory"
          :data="dataHistory"
          :limit="10"
          @pagination-change-page="paginateHistory"
        ></Pagination>
      </div>
    </div>
  </b-modal>
</template>

<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
export default {
  components: { OverlayButton, Pagination },
  props: {
    isLoadingHistory: {
      type: Boolean,
      default: false,
    },
    dataHistory: {
      type: Object,
      default: null,
    },
    recordsHistory: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: ["Id", "Tipo", "Fecha", "Detalles"],
      fields2: [
        {
          key: "column",
          label: "Columna",
        },
        {
          key: "oldValue",
          label: "Valor Anterior",
        },
        {
          key: "newValue",
          label: "Valor Nuevo",
        },
      ],
      page: 1,
    };
  },
  methods: {
    paginateHistory(page) {
      const me = this;
      me.page = page;
      me.$emit("loadPageHistory", me.page);
    },
  },
};
</script>
<style lang="scss">
.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}
.title-modal-kinney {
  font-size: 18px;
}
.content-formula {
  background-color: #f6ffed;
  padding: 8px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
}
.table-detail {
  box-shadow: 0 0 0 0 !important;
}
.table-detail thead tr th {
  background: #cfd8dc !important;
  border-radius: 0px !important;
}
</style>
